import Cookies from 'js-cookie'

import locator from '@/service-locator'
import { getTamaraDomainCookieAttributes } from '@/utils/cookie-storage'

const buildSharedTokenKey = (env) => {
  return `tamara-partner-shared-token-${env}`
}

const setSharedTokenToCookies = (token) => {
  const key = buildSharedTokenKey(locator.config.env)
  const attributes = getTamaraDomainCookieAttributes(window)

  return Cookies.set(key, token, attributes)
}

const removeSharedTokenFromCookies = () => {
  const key = buildSharedTokenKey(locator.config.env)
  const attributes = getTamaraDomainCookieAttributes(window)

  return Cookies.remove(key, attributes)
}

const handleRedirectOnboardingV2 = (userToken) => {
  const onboardingPageUrl = locator.config.onboardingPageUrl

  setSharedTokenToCookies(userToken)

  if (onboardingPageUrl) {
    window.location.href = onboardingPageUrl
  }
}

const handleRedirectUserToOnboarding = (userToken, router, { apiVersion }) => {
  if (apiVersion === 'v2') {
    return handleRedirectOnboardingV2(userToken)
  }

  router.push({ path: '/onboarding' })
}

export {
  handleRedirectOnboardingV2,
  setSharedTokenToCookies,
  removeSharedTokenFromCookies,
  handleRedirectUserToOnboarding,
}
